var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgS(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41.6 52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.08 52-8.08-8.17v-11.08l3.7-1.78-3.7-3.7v-14.55l12.58-12.72h20.83l8.19 8.21v11.27l-3.7 1.77 3.7 3.7v14.38l-4.83 4.83-7.86 7.84z",
    className: "cjd-border",
    fill: "#525a6f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m40.5 18.76v-10.09l-7.56-7.57h-19.89l-11.95 12.08v13.62l4.5 4.5-4.5 2.16v9.9l7.45 7.54h19.89l7.56-7.52 4.52-4.52v-13.44l-4.52-4.5z",
    className: "cjd-stroke",
    fill: "#8089a2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m26.17 28.68h-12.65l-6.87-6.85v-12.68l6.87-6.91h19l6.87 6.9v8.44h-11.88v-4.25l-1.34-1.33h-6.3l-1.39 1.38v4.31l1.39 1.31h12.6l6.87 6.92v12.5l-6.87 6.86h-18.95l-6.87-6.89v-8.26h11.83v4l1.39 1.4h6.3l1.34-1.35v-4.11z",
    className: "cjd-fill",
    fill: "#f9fbfe"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS);
export default __webpack_public_path__ + "static/media/s.f78eb6543cc91b74f7d480d38060cf2b.svg";
export { ForwardRef as ReactComponent };